import React from 'react';
import PricingWidget from './PricingWidget';
export const priceOptionColumns = [
    {
        key: "option_name", label: 'menu.extras.columns.optionName',
        componentTransform: (name: string, key: any) => {
            return <span key={`${key}-date`}>{name}</span>
        }
    },
    {
        key: "option_price", label: 'menu.extras.columns.optionPriceInc',
        componentTransform: (price: any, key: any) => {
            return <PricingWidget key={`${key}-date`} price={price}/>
        }
    },
    {
        key: "option_price_exclusive", label: 'menu.extras.columns.optionPriceExcl',
        componentTransform: (price: any, key: any) => {
            return  <PricingWidget key={`${key}-date`} price={price}/>
        }
    },
    {
        key: "option_discount", label: 'menu.extras.columns.optionDiscount',
        componentTransform: (discount: any, key: any) => {
            return  <span key={`${key}-date`}>{discount}</span>
        }
    },
];